import { render, staticRenderFns } from "./OrderHistoryPage.vue?vue&type=template&id=c807b46c&scoped=true&"
import script from "./OrderHistoryPage.vue?vue&type=script&lang=js&"
export * from "./OrderHistoryPage.vue?vue&type=script&lang=js&"
import style0 from "./OrderHistoryPage.vue?vue&type=style&index=0&id=c807b46c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c807b46c",
  null
  
)

export default component.exports